import { getNfeIntegration } from "./nfe";
import { FinancialFilterValues, FinancialTab, RebuildPayload } from "./types";

function setParam(
  params: Record<string, string | number>,
  key: string,
  value: string | number | null | undefined
) {
  if (value === null || value === undefined || value === "") return;
  params[key] = value;
}

export function toFinancialParams(
  tab: FinancialTab,
  filters: FinancialFilterValues,
  page: number,
  pageSize: number
): Record<string, string | number> {
  const params: Record<string, string | number> = {
    page,
    page_size: pageSize,
  };
  const year = filters.year === "" ? undefined : Number(filters.year);
  const month = filters.month === "" ? undefined : Number(filters.month);

  if (tab === "nfe") {
    params.page_size = Math.min(pageSize, 50);
    setParam(params, "integration", filters.integration.trim());
    setParam(params, "agreement_id", filters.agreement_id);
    setParam(params, "cpf", filters.cpf.trim());
    setParam(params, "user_id", filters.user_id.trim());
    setParam(params, "product_id", filters.product_id);
    setParam(params, "plan_slug_integration", filters.plan_slug_integration.trim());
    setParam(params, "level_id", filters.level_id);
    setParam(params, "media_type", filters.media_type);
    if (year) setParam(params, "year", year);
    if (year && month) setParam(params, "month", month);

    const integration = getNfeIntegration(filters.integration.trim());
    const status = filters.status.trim();
    if (integration?.status === "hubsoft" && status && status !== "todos") {
      setParam(params, "status", status);
    }
    if (integration?.status === "text") setParam(params, "status", status);
    if (integration?.tipo) setParam(params, "tipo", filters.tipo.trim());
    if (integration?.situacao) setParam(params, "situacao", filters.situacao.trim());
    if (integration?.modelo) setParam(params, "modelo", filters.modelo.trim());
    return params;
  }

  setParam(params, "agreement_id", filters.agreement_id);
  setParam(params, "level_id", filters.level_id);

  if (tab === "clients_by_category") {
    if (year) setParam(params, "year", year);
    if (year && month) setParam(params, "month", month);
    return params;
  }

  if (tab === "media") {
    setParam(params, "cpf", filters.cpf.trim());
    if (year) setParam(params, "year", year);
    if (year && month) setParam(params, "month", month);
    setParam(params, "media_type", filters.media_type);
    return params;
  }

  if (tab === "client_plans") {
    setParam(params, "cpf", filters.cpf.trim());
    if (year) setParam(params, "year", year);
    if (year && month) setParam(params, "month", month);
    return params;
  }

  if (tab === "clients_by_plan") {
    setParam(params, "plan_slug_integration", filters.plan_slug_integration.trim());
    setParam(params, "cpf", filters.cpf.trim());
    if (year) setParam(params, "year", year);
    if (year && month) setParam(params, "month", month);
    return params;
  }

  setParam(params, "product_id", filters.product_id);

  if (tab === "plans_by_category") return params;

  setParam(params, "plan_slug_integration", filters.plan_slug_integration.trim());

  setParam(params, "cpf", filters.cpf.trim());
  setParam(params, "user_id", filters.user_id.trim());
  if (year) setParam(params, "year", year);
  if (year && month) setParam(params, "month", month);

  return params;
}

export function toClientsByCategoryWriteParams(params: Record<string, string | number>) {
  const next = { ...params };
  delete next.page;
  delete next.page_size;
  return next;
}

export function toRebuildPayload(values: FinancialFilterValues): RebuildPayload {
  const payload: RebuildPayload = {};
  const year = values.year === "" ? undefined : Number(values.year);
  const month = values.month === "" ? undefined : Number(values.month);

  if (values.agreement_id) payload.agreement_id = values.agreement_id;
  if (year) payload.year = year;
  if (year && month) payload.month = month;

  return payload;
}

export function financialRowId(tab: FinancialTab, row: Record<string, unknown>, index: number) {
  if (tab === "clients_by_plan") {
    return [row.agreement_id, row.plan_slug_integration, row.plan_id, row.product_id, row.level_id].join("-");
  }
  if (tab === "client_plans") {
    return [row.cpf, row.agreement_id, row.plan_id, row.product_id].join("-");
  }
  if (tab === "clients_by_category" || tab === "plans_by_category") {
    return String(row.level_id ?? index);
  }
  if (tab === "nfe") {
    return [row.integration, row.agreement_id, row.id_nota ?? row.id_nfe, row.numero_nf, index].join("-");
  }
  return [row.cpf, row.plan_id, row.product_id, row.year, row.month ?? "year", row.media_type].join("-");
}
